import { Div, MultilineInput, RefString, Span, Tabs } from "@tblabs/truffle";
import { Center } from "../../Components/Utils/Center";
import { OrdersManager } from "../../Services/Storage/OrdersManager";
import { CustomerStepsPrinter } from "../../Components/StepsPrinter";
import { OrderEventsCalendar } from "../../Components/OrderEventsCalendar";
import { Order } from "../../Models/Order";
import { Page } from "../Page";
import { InfoBox } from "./InfoBox";


export class CustomerOrderViewPage extends Page
{
    private order: Order | null = null;

    constructor(
        private _manager: OrdersManager,
        private orderId: string)
    {
        super("Zamówienie #" + orderId);

        this.OnError((ex: Error) =>
        {
            console.error(ex);

            if (!this.order)
            {
                const shortId = this.orderId.slice(-5).toUpperCase();
                return ({ header: "Nie znaleziono zamówienia", body: `Skontaktuj się z obsługą sklepu podając ten numer: ${shortId}` });
            }

            return ({ header: "Error", body: ex.message });
        });

        this.Content(async (body) => 
        {
            const order: Order | null = await this._manager.GetOne(this.orderId);

            if (order.IsClosed)
            {
                body.Append(
                    new Center("Zamówienie jest już zamknięte. Jeśli chcesz je przywrócić, skontaktuj się z obsługą sklepu.").MarginTop(32)
                )
                return;
            }

            const view = new RefString("🐾 Przebieg zamówienia").Storable("customer-order-view");

            const tabs = new Tabs(view)//.Style(`overflow-x: auto; flex-wrap: nowrap;`);
            tabs.Add("🐾 Przebieg zamówienia", () => new CustomerStepsPrinter(order))
                .Add("📅 Kalendarz", () => new Center(new OrderEventsCalendar(order)).MarginTopBottom(32)) 

            if (order.Notes.Public.value)
                tabs.Add("📝 Notatka", () => new Center(new MultilineInput(order.Notes.Public).Readonly().Rows(20).MarginTop(16).Padding(12).BorderRadius(8)))

            // if (this.CHAT_VISIBLE)
            // {
            //     const _connector = new RemoteStorageChatConnector(this._messageBus, order.Id);
            //     const chat = new Chat(_connector, new ChatUser({ Name: `Klient #${order.ShortId}` }));
            //     await _connector.Load();

            //     tabs.Add(`💬 Czat${chat.IsUnread ? "🔴" : ""}`, () => new ChatView(chat));
            // }

            body.Append(
                new Div().TextAlignLeft().MarginBottom(16).Padding(16).Append(
                    new Span("Zamówienie #" + order.ShortId)
                        .FontSize(24).Bold().Color("#1e87f0")
                        .Margin(0)
                        .MarginTop(0).MarginBottom(16),
                    "\n",
                    new Span(order.CurrentStateForCustomer)
                        .FontSize(16).Color("#888")
                        .Margin(0)
                        .MarginTop(0).MarginBottom(16),
                ),
                tabs,
                // new Line().Margin(16),
                new InfoBox(
                    "Chcesz coś zmienić w zamówieniu?",
                    "Zadzwoń lub napisz: ☎️ +48 507 293 714"
                ),
            )
        });
    }
}
